export default __webpack_public_path__ + "static/media/Shaka_particle_final_13.9a8f1706.png";